<!--SECTION-->
<section
    data-testid="category-poster"
    hBindSPANavigationForCTA
    [hAnimateOnScroll]="{
        animate: categoryPoster.hasAnimation,
        rootMargin: '0px 0px -150px 0px',
    }"
    class="block-edito-block-category-poster">
    <!-- List of Line-->
    <div class="block-media">
        @for (line of categoryPoster.imageLines; track line; let lineIndex = $index) {
            <ul
                class="category-poster-line"
                [ngClass]="
                    line.isThumbnail ? 'category-poster-line-thumbnails' : 'category-poster-line-' + line.images.length
                ">
                <!-- List of image-->
                @for (imageData of line.images; track imageData; let imageIndex = $index) {
                    @if (imageData.imageCta) {
                        <li class="category-poster-image-wrapper">
                            <a
                                (click)="sendAnalyticsEvent(lineIndex, imageIndex, imageData)"
                                data-cta-spa
                                class="category-poster-cta"
                                hBindSPANavigationForCTA
                                [attr.href]="setCTA(imageData)"
                                [attr.aria-label]="imageData?.imageCta?.text">
                                <ng-template
                                    [ngTemplateOutlet]="imageBlock"
                                    [ngTemplateOutletContext]="{ $implicit: imageData }"></ng-template>

                                <span i18n class="category-poster-text heading-6 regular-uppercase">{{
                                    imageData.title
                                }}</span>
                            </a>
                        </li>
                    } @else {
                        <li class="category-poster-image-wrapper">
                            <div>
                                <ng-template
                                    [ngTemplateOutlet]="imageBlock"
                                    [ngTemplateOutletContext]="{ $implicit: imageData }"></ng-template>

                                <span i18n class="category-poster-text heading-6 regular-uppercase">{{
                                    imageData.title
                                }}</span>
                            </div>
                        </li>
                    }
                }
            </ul>
        }
        <!-- Block Image+Text-->
    </div>
</section>

<ng-template #imageBlock let-imageData>
    <div class="category-poster-image">
        <div class="media-wrap">
            <h-media-picture
                class="picture"
                [mediaPicture]="{ mobileImage: imageData.url, desktopImage: imageData.url }"
                [preloadPoster]="false"
                [mediaQueriesOptions]="mediaOptions"></h-media-picture>
        </div>
    </div>
</ng-template>
